import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AiMappingUpgradeButton from "./AiMappingUpgradeButton";

export default function AiMappingUpsell() {
  return (
    <MDBox textAlign="center" data-testid="ai-mapping-upsell">
      <MDTypography variant="h6" fontWeight="medium">
        Map with AI
      </MDTypography>
      <MDTypography variant="body2" color="text" mt={1} mb={2}>
        Automatically detect parking stalls, ADA stencils, arrows and more from satellite imagery.
        AI mapping is available as an add-on to your subscription.
      </MDTypography>
      <AiMappingUpgradeButton fullWidth />
    </MDBox>
  );
}
